import { Button, FloatButton, Image, Input, Popover, Upload, message } from 'antd'
import styles from './index.module.scss'
import { useEffect, useMemo, useState } from 'react'
import { CloseOutlined, CustomerServiceOutlined, DeploymentUnitOutlined, PhoneOutlined, PlusOutlined, QuestionOutlined, ReadOutlined, WechatOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import Utils from '@utils/utils'
import API from '@api/api'
import PSAIModal from '@PSAIComponents/PSAIModal'
import Iconfont from '@utils/Iconfont';

const Feedback = (props) => {
    const [comments, setComments] = useState('');
    const [fileList, setFileList] = useState([]);
    const [contact, setContact] = useState('');
    const [loading, setLoading] = useState()

    const uploadButton = (
        <div>
            <PlusOutlined style={{ fontSize: '22px', color: '#979797' }} />
        </div>
    );

    function feedback(fileUrls) {
        return API.feedback({
            comments: comments,
            contact: contact,
            attachments: fileUrls,
        }).then(res => {
            if (res.code == 0) {
                message.success('感谢您提交的问题，我们将对问题进行改进并反馈！', 10)
            } else {
                message.error(res.message)
            }
        })
    }

    const onSubmit = async () => {
        try {
            setLoading(true)
            if (!comments) {
                message.warning('请输入问题描述')
                return setLoading(false)
            }
            // 需要登录
            const status = Utils.checkLoginStatus(() => onSubmit())
            if (!status) return

            let fileUrls = []
            if (fileList.length > 0) {
                // AAA
                const list = fileList.map(item => Utils.checkImageIslegal(item.originFileObj, 0))
                fileUrls = await Promise.all(list) // 这不需要存审核ID
                if (fileUrls.findIndex(item => !item) >= 0) return setLoading(false)
                const isLegal = fileUrls.some(item => !item.isLegal);
                if (isLegal) {
                    PSAIModal.confirm({
                        content: '经检测，您上传的内容涉嫌违规，已进行屏蔽处理，人工审核会对图片进行复核。',
                        okText: '检查图片',
                        cancelText: '取消',
                        onOk() { },
                        onCancel() { },
                    })
                    return false
                }
            }
            await feedback(fileUrls.map(item => item.data))

            return props.onCancel()
        } catch (err) {
            message.error(err.message)
        } finally {
            setLoading(false)
        }
    }

    const onCancel = () => {
        props.onCancel()
    }

    return (
        <div className={styles.FeedbackContainer}>
            <div className={styles.FormContent}>
                <div className={styles.FormItem}>
                    <label htmlFor="feedback_comments">问题描述<span>*</span></label>
                    <div className={styles.FormItemContent}>
                        <Input.TextArea
                            id="feedback_comments"
                            showCount
                            maxLength={300}
                            style={{ height: 150 }}
                            onChange={e => setComments(e.target.value)}
                            value={comments}
                            placeholder="请详细描述您遇到的问题，我们会努力改进为您提供更好的服务~"
                        />
                    </div>
                </div>
                <div className={styles.FormItem}>
                    <label htmlFor="feedback_files">问题图片</label>
                    <div className={styles.FormItemContent}>
                        <Upload
                            id="feedback_files"
                            accept='image/jpeg,image/png,image/webp,image/avif'
                            listType="picture-card"
                            fileList={fileList}
                            beforeUpload={() => false}
                            onPreview={() => { return false }}
                            onChange={(fileList) => setFileList(fileList.fileList)}
                            maxCount={3}
                            showUploadList={{ showPreviewIcon: false }}
                        >
                            {fileList.length >= 3 ? null : uploadButton}
                        </Upload>
                    </div>
                </div>
                <div className={styles.FormItem}>
                    <label htmlFor="feedback_contact">您的联系方式</label>
                    <div className={styles.FormItemContent}>
                        <Input
                            id="feedback_contact"
                            value={contact}
                            maxLength={20}
                            onChange={e => setContact(e.target.value)}
                            placeholder="手机号/邮箱/微信号"
                        />
                    </div>
                </div>
            </div>
            <div className={styles.BtnContent}>
                <Button onClick={onCancel}>取消</Button>
                <Button type="primary" onClick={onSubmit} loading={loading}>提交反馈</Button>
            </div>
        </div>
    )
}

const FloatHelper = () => {
    const location = useLocation()
    const defaultOpenRoutes = ['/', '/homePageMaster', '/homePageMasterSub']
    const isDefaultOpenRoute = defaultOpenRoutes.includes(location.pathname)

    const [open, setOpen] = useState(() => {
        return isDefaultOpenRoute
    })

    const [qrcodeVisible, setQrcodeVisible] = useState(false)

    // 监听路由变化，动态更新展开状态
    useEffect(() => {
        if (isDefaultOpenRoute) {
            setOpen(true)
        } else {
            setOpen(false)
        }
    }, [isDefaultOpenRoute])

    const items = useMemo(() => {
        return [{
            label: "操作指南",
            key: 3,
            link: "https://arcsoft.feishu.cn/docx/WrEFdAObEo0KWkxlwM3cigkhnxg",
            hoverColor: '#006EFF',
            icon: <Iconfont type="icon-guideOutlined1" />
        }, {
            label: "电话咨询",
            key: 6,
            showPhone: true,
            hoverColor: '#006EFF',
            icon: <Iconfont type="icon-phoneOutlined1" />
        }, {
            label: "微信咨询",
            key: 7,
            showQrcode: true,
            qrcodeTitle: '💬 微信咨询产品功能 💬',
            qrcodeDesc: '请扫码添加客服微信',
            hoverColor: '#34C759',
            icon: <Iconfont type="icon-wechatOutlind" />
        }, {
            label: "在线客服",
            key: 5,
            link: "https://work.weixin.qq.com/kfid/kfc6d97c26a6d286b38",
            hoverColor: '#006EFF',
            icon: <Iconfont type="icon-CustomerOutlind" />
        }, {
            label: "行业方案",
            key: 8,
            showQrcode: true,
            qrcodeTitle: '🔥 定制行业解决方案 🔥',
            qrcodeDesc: '请扫码添加客服微信',
            hoverColor: '#FFC629',
            icon: <Iconfont type="icon-solutionOutlined" />
        }]
    }, [])

    const getQrcodeContent = (item) => (
        <div className={styles.HelprQRCode}>
            <p>{item?.qrcodeTitle}</p>
            <img
                src={Utils.qrcodeSales}
                alt="扫码联系我们"
                onClick={(e) => {
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    setQrcodeVisible(true);
                }}
                style={{ cursor: 'pointer' }}
            />
            <p>{item?.qrcodeDesc}</p>
        </div>
    )

    const servicePhone = '0571‑8821 0600'

    const handleCopyPhone = () => {
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(servicePhone)
                .then(() => {
                    message.success('已复制服务热线')
                })
                .catch(() => {
                    message.error('复制失败，请手动复制')
                })
            return
        }

        const textarea = document.createElement('textarea')
        textarea.value = servicePhone
        textarea.style.position = 'fixed'
        textarea.style.top = '-9999px'
        document.body.appendChild(textarea)
        textarea.focus()
        textarea.select()

        try {
            const success = document.execCommand('copy')
            if (success) {
                message.success('已复制服务热线')
            } else {
                message.warning('复制失败，请手动复制')
            }
        } catch (err) {
            console.error('Fallback copy error:', err)
            message.error('复制失败，请手动复制')
        }

        document.body.removeChild(textarea)
    }

    const phoneContent = (
        <div className={styles.HelprPhone} onClick={handleCopyPhone} style={{ cursor: 'pointer' }}>
            <div className={styles.PhoneLabel}>客户服务热线 <Iconfont type="icon-copyOutlined1" /></div>
            <div className={styles.PhoneNumber}>{servicePhone}</div>
        </div>
    )

    const onClick = (item) => {
        if (item.link) window.open(item.link)
    }

    return (
        <>
            <FloatButton.Group
                trigger="click"
                open={open}
                onOpenChange={(nextOpen) => setOpen(isDefaultOpenRoute ? true : nextOpen)}
                icon={open ? <CloseOutlined /> : <Iconfont style={{ color: '#fff' }} type="icon-wechatOutlind" />}
                className={`${styles.HelperFloatGroup} ${open ? styles.HelperOpen : styles.HelperClosed} ${!isDefaultOpenRoute && !open ? styles.HelperPeek : ''}`}
                shape="square"
            >
                {
                    items.map((item) => {

                        const buttonNode = (
                            <FloatButton
                                key={item.key}
                                shape="square"
                                className={styles.HelperFloatItem}
                                style={{ '--helper-hover-color': item.hoverColor }}
                                icon={item.icon}
                                description={item.label}
                                onClick={() => onClick(item)}
                            />
                        )

                        if (item.showQrcode) {
                            return (
                                <Popover
                                    key={item.key}
                                    trigger="hover"
                                    placement="left"
                                    content={getQrcodeContent(item)}
                                    overlayClassName={styles.HelperQrcodePopover}
                                    getPopupContainer={() => document.getElementById('root')}
                                >
                                    {buttonNode}
                                </Popover>
                            )
                        }

                        if (item.showPhone) {
                            return (
                                <Popover
                                    key={item.key}
                                    trigger="hover"
                                    placement="left"
                                    content={phoneContent}
                                    overlayClassName={styles.HelperPhonePopover}
                                    getPopupContainer={() => document.getElementById('root')}
                                >
                                    {buttonNode}
                                </Popover>
                            )
                        }

                        return buttonNode
                    })
                }
            </FloatButton.Group>
            {/* 增加一个绝对定位的父容器，脱离文档流，防止 Image 挂载时撑开页面引起滚动 */}
            <div style={{ position: 'absolute', top: 0, left: 0, width: 0, height: 0, overflow: 'hidden', pointerEvents: 'none' }}>
                <Image
                    style={{ display: 'none' }}
                    src={Utils.qrcodeSales}
                    preview={{
                        getContainer: '#root',
                        visible: qrcodeVisible,
                        imageRender: () => (
                            <div style={{
                                width: 300,
                                height: 392,
                                backgroundColor: '#F0F5FA',
                                borderRadius: 28,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                paddingTop: 20,
                                boxSizing: 'border-box'
                            }}>
                                <img style={{ width: 260, height: 260, borderRadius: 12, objectFit: 'cover' }} src={Utils.qrcodeSales} alt="扫码联系我们" />
                                <div style={{ marginTop: 24, textAlign: 'center', color: '#121316', fontSize: 16, lineHeight: '24px', fontWeight: 400 }}>
                                    <p style={{ margin: 0 }}>扫码添加</p>
                                    <p style={{ margin: 0 }}>客户服务微信</p>
                                </div>
                            </div>
                        ),
                        toolbarRender: () => null,
                        onVisibleChange: (value) => setQrcodeVisible(value),
                    }}
                />
            </div>
        </>
    )
}

export default FloatHelper